import Qs from 'qs'
import axios from 'axios'
import getField from '@/utils/getField'
import store from '@/store'
import { ElMessage } from 'element-plus'

const requestConfig = {
  baseURL: import.meta.env.VITE_APP_BASE_API, // api base_url
  timeout: 0, // 105000, // request timeout
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  transformRequest: [
    function (data) {
      return JSON.stringify(data)
    }
  ],
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: 'repeat' })
  }
}

// axios instance data only
const service = axios.create(requestConfig)

service.interceptors.response.use(
  response => response.data,
  error => handleError(error)
)

// axios instance for full response
const serviceFullResponse = axios.create(requestConfig)

serviceFullResponse.interceptors.response.use(
  response => response,
  error => handleError(error)
)

function handleError (error) {
  const errorMessage = getField(error, 'response.data.body.exception') ||
    getField(error, 'response.data.exception') ||
    getField(error, 'response.data.message') ||
    error.message

  let unauthorized = false

  if (error.response !== undefined) {
    switch (error.response.status) {
      case 409:
      case 403:
        // eslint-disable-next-line
        console.error('Error: %o', errorMessage)
        break
      case 401:
        unauthorized = true
        // eslint-disable-next-line
        console.error('UNAUTHORIZED!!!!!!')
        if (!location.pathname.startsWith('/login')) {
          store.dispatch('logout').then(() => {
            self.location.reload()
          })
        }
        break
      default:
        break
    }
  }

  // show error for non-401 only and if error is not expected
  if (!unauthorized && !(error.config.expectedErrorCodes || []).includes(error.response?.status)) {
    ElMessage({
      message: errorMessage,
      type: 'error',
      duration: 5 * 1000
    })
  }

  return Promise.reject(error)
}

// exports
export function request () {
  return service(...arguments)
}

export function requestFullResponse () {
  return serviceFullResponse(...arguments)
}
